import axios from "axios";

export const quickshare_actions = {
  async loadQuickShareFromKey(key) {
    try {
      const url = `${
        import.meta.env.VITE_APP_UCHI_API_ENDPOINT
      }/shares/${key}?include=colors,customerdesign,resellerdesign`;
      const config = {
        headers: {
          apikey: import.meta.env.VITE_APP_UCHI_API_KEY,
          "x-functions-key": import.meta.env.VITE_APP_UCHI_FUNCTION_KEY
        }
      };
      const response = await axios.get(url, config);
      this.quickshare = response.data;
      this.quickShareKeyState = key;
      this.sessionCode = response.data.sessionToken;

      if (response.data.colors) {
        this.setTheme(
          response.data.colors.map(c => ({ typename: "colors", key: c.key.toLowerCase(), value: c.value }))
        ); // From settings.js
      }
      if (response.data.customerDesign) {
        this.setTheme(
          response.data.customerDesign.map(c => ({
            typename: "customerdesign",
            key: c.key.toLowerCase(),
            value: c.value
          }))
        ); // From settings.js
      }
      if (response.data.resellerDesign) {
        this.setTheme(
          response.data.resellerDesign.map(c => ({
            typename: "resellerdesign",
            key: c.key.toLowerCase(),
            value: c.value
          }))
        ); // From settings.js
      }
    } catch (err) {
      if (err.response && err.response.data === "Share has expired") {
        throw new Error();
      }
    }
  },

  async validatePasswordOnQuickShare(key, password) {
    const url = `${import.meta.env.VITE_APP_UCHI_API_ENDPOINT}/shares/${key}/verify`;
    const body = { code: password };
    const config = {
      headers: {
        apikey: import.meta.env.VITE_APP_UCHI_API_KEY,
        "x-functions-key": import.meta.env.VITE_APP_UCHI_FUNCTION_KEY
      }
    };
    try {
      const response = await axios.post(url, body, config);

      if (response.data.sessionToken) {
        this.sessionCode = response.data.sessionToken;
        return this.sessionCode;
      }
    } catch (err) {
      return null;
    }
  },

  async resendPasswordOnQuickShare(externId) {
    const url = `${import.meta.env.VITE_APP_UCHI_API_ENDPOINT}/shares/${externId}/resend`;
    const config = {
      headers: {
        apikey: import.meta.env.VITE_APP_UCHI_API_KEY,
        "x-functions-key": import.meta.env.VITE_APP_UCHI_FUNCTION_KEY
      }
    };
    const response = await axios.get(url, config);
    return response.data;
  }
};

export const quickshare_getters = {
  quickShareTitle(state) {
    return state.quickshare?.title;
  },

  quickShareSessionToken(state) {
    return state.sessionCode;
  },

  quickShareKey(state) {
    return state.quickShareKeyState;
  }
};

export const quickshare_state = {
  quickshare: null,
  sessionCode: null
};
